/**
 * OrbDocTutorialsIntermediateUiPatternsAROrbDocTutorialsIntermediateUiPatternsARPage
 *
 * Page component for OrbDocTutorialsIntermediateUiPatternsAROrbDocTutorialsIntermediateUiPatternsARPage
 * Path: /ar/docs/tutorials/intermediate/ui-patterns
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocTutorialsIntermediateUiPatternsARDocScreenView as __OrbDocTutorialsIntermediateUiPatternsARDocScreenView } from '@/components/traits/OrbDocTutorialsIntermediateUiPatternsARDocScreenView';
import { OrbDocTutorialsIntermediateUiPatternsARDocAnalyticsView as __OrbDocTutorialsIntermediateUiPatternsARDocAnalyticsView } from '@/components/traits/OrbDocTutorialsIntermediateUiPatternsARDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocTutorialsIntermediateUiPatternsAROrbDocTutorialsIntermediateUiPatternsARPageProps {
  // Add any page-level props here
}

export function OrbDocTutorialsIntermediateUiPatternsAROrbDocTutorialsIntermediateUiPatternsARPage(_props: OrbDocTutorialsIntermediateUiPatternsAROrbDocTutorialsIntermediateUiPatternsARPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"تركيب شاشة من الأنماط","description":"ابنِ لوحة معلومات صغيرة من أنماط التخطيط والبيانات والتنبيه، مع تبويبات تبدّل الجسم المعروض.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/tutorials/intermediate/ui-patterns"},{"locale":"ar","path":"/ar/docs/tutorials/intermediate/ui-patterns"},{"locale":"sl","path":"/sl/docs/tutorials/intermediate/ui-patterns"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocTutorialsIntermediateUiPatternsARDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocTutorialsIntermediateUiPatternsARDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocTutorialsIntermediateUiPatternsAROrbDocTutorialsIntermediateUiPatternsARPage;
